import streetsJson from '../constants/israelStreetsBySettlement.json';
import { ISRAEL_STREET_CATALOG_EXTRAS } from '../constants/israelStreetCatalogExtras';
import { settlementIdForWireCity } from './israelSettlements';

const STREETS_BY_SETTLEMENT = streetsJson as Record<string, string[]>;

const MERGED_STREETS_BY_SETTLEMENT = new Map<string, readonly string[]>();

export function israelStreetSettlementCount(): number {
  return Object.keys(STREETS_BY_SETTLEMENT).length;
}

export function streetsForSettlementId(settlementId: string | number | null | undefined): readonly string[] {
  if (settlementId == null || settlementId === '') {
    return [];
  }
  const key = String(settlementId);
  const cached = MERGED_STREETS_BY_SETTLEMENT.get(key);
  if (cached) {
    return cached;
  }
  const base = STREETS_BY_SETTLEMENT[key] ?? [];
  const extras = ISRAEL_STREET_CATALOG_EXTRAS[key] ?? [];
  if (extras.length === 0) {
    MERGED_STREETS_BY_SETTLEMENT.set(key, base);
    return base;
  }
  const seen = new Set(base);
  const merged = [...base];
  for (const street of extras) {
    const trimmed = street.trim();
    if (!trimmed || seen.has(trimmed)) {
      continue;
    }
    seen.add(trimmed);
    merged.push(trimmed);
  }
  MERGED_STREETS_BY_SETTLEMENT.set(key, merged);
  return merged;
}

export function streetsForCityWire(cityWire: string): readonly string[] {
  const settlementId = settlementIdForWireCity(cityWire);
  if (!settlementId) {
    return [];
  }
  return streetsForSettlementId(settlementId);
}

export function searchIsraelStreets(
  cityWire: string,
  query: string,
  limit = 80,
): string[] {
  const streets = streetsForCityWire(cityWire);
  const trimmed = query.trim();
  if (!trimmed) {
    return streets.slice(0, limit);
  }
  const lower = trimmed.toLowerCase();
  const results: string[] = [];
  for (const street of streets) {
    if (street.includes(trimmed) || street.toLowerCase().includes(lower)) {
      results.push(street);
      if (results.length >= limit) {
        break;
      }
    }
  }
  return results;
}

export function isKnownIsraelStreet(cityWire: string, street: string): boolean {
  const trimmed = street.trim();
  if (!trimmed) {
    return false;
  }
  return streetsForCityWire(cityWire).some((candidate) => candidate === trimmed);
}
